import type { RequestStatus } from "../api/requests";
import type { StatusPresentation } from "./operationStatus";

/** Maps a money-request status to tone + i18n key under `receipt.*`. */
export const requestToStatusPresentation = (
  status: RequestStatus
): StatusPresentation => {
  switch (status) {
    case "pending":
      return { tone: "initial", labelKey: "receipt.statusPending" };
    case "accepted":
      return { tone: "progress", labelKey: "receipt.statusAccepted" };
    case "funded":
      return { tone: "completed", labelKey: "receipt.statusFunded" };
    case "failed":
      return { tone: "failed", labelKey: "receipt.statusFailed" };
    case "cancelled":
      return { tone: "failed", labelKey: "receipt.statusCancelled" };
    case "expired":
      return { tone: "expired", labelKey: "receipt.statusExpired" };
    default:
      return { tone: "initial", labelKey: "receipt.status" };
  }
};

/** @deprecated Prefer `requestToStatusPresentation(status).labelKey`. */
export const requestStatusKey = (status: RequestStatus): string =>
  requestToStatusPresentation(status).labelKey;
